var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProspects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 6.5H6C4.344 6.5 3 7.8425 3 9.5V39.5C3 41.1575 4.344 42.5 6 42.5H42C43.6575 42.5 45 41.1575 45 39.5V9.5C45 7.8425 43.6575 6.5 42 6.5ZM6 39.5V9.5H42V39.5H6ZM9 15.5H19.5V18.5H9V15.5ZM15 21.5H9V24.5H15V21.5ZM39 32C39 29.5145 36.9855 27.5 34.5 27.5H25.5C23.0145 27.5 21 29.5145 21 32V35H24V32C24 31.172 24.672 30.5 25.5 30.5H34.5C35.328 30.5 36 31.172 36 32V35H39V32ZM33 20C33 18.3425 31.6575 17 30 17C28.344 17 27 18.3425 27 20C27 21.6575 28.344 23 30 23C31.6575 23 33 21.6575 33 20ZM36 20C36 23.3135 33.3135 26 30 26C26.6865 26 24 23.3135 24 20C24 16.6865 26.6865 14 30 14C33.3135 14 36 16.6865 36 20Z",
    fill: "url(#paint0_linear_87_7882)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_7882",
    x1: 3,
    y1: 7.12088,
    x2: 36.0509,
    y2: 50.7184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProspects);
export default __webpack_public_path__ + "static/media/empty-prospects.fb90e14b0f29dc1d692b086bde5a6813.svg";
export { ForwardRef as ReactComponent };